import { BaseClient, logisticsApi } from '../../shared';
import { IClosedDay, IClosedDayQuery, ISaveClosedDays } from '../models';

class ClosedDaysClient extends BaseClient<IClosedDay, ISaveClosedDays, IClosedDayQuery> {
    constructor() {
        super(logisticsApi, '/closed-days');
    }

    public async createClosedDays(item: ISaveClosedDays): Promise<IClosedDay[]> {
        const { data } = await this.api.post<IClosedDay[]>(this.basePath, item);
        return data;
    }
}

export const closedDaysClient = new ClosedDaysClient();
